import { createRoutine } from 'redux-saga-routines';

export const clearChannelData = createRoutine('CLEAR_CHANNEL_DATA');
export const clearChannelMessagesData = createRoutine('CLEAR_CHANNEL_MESSAGES_DATA');
export const createChannel = createRoutine('CHANNEL_CREATE');
export const fetchGroups = createRoutine('FETCH_GROUPS');
export const fetchUsersBatchFromGroup = createRoutine('FETCH_USERS_BATCH_FROM_GROUP');
export const fetchUsersFromGroup = createRoutine('FETCH_USERS_FROM_GROUP');
export const removeChannel = createRoutine('REMOVE_CHANNEL');
export const reorderChannels = createRoutine('REORDER_CHANNELS');
export const sendMessageAsAlertUser = createRoutine('SEND_MESSAGE_AS_ALERT_USER');
export const stopSyncingChannelMessages = createRoutine('STOP_SYNCING_CHANNEL_MESSAGES');
export const stopSyncingChannels = createRoutine('STOP_SYNCING_CHANNELS');
export const syncChannelMessages = createRoutine('SYNC_CHANNEL_MESSAGES');
export const syncChannels = createRoutine('SYNC_CHANNELS');
export const toggleBlockChannelMessage = createRoutine('TOGGLE_BLOCK_CHANNEL_MESSAGE');
export const updateChannel = createRoutine('CHANNEL_UPDATE');
export const updateChannelName = createRoutine('CHANNEL_NAME_UPDATE');
